import { createContext, useContext } from "react";
const BiContext = createContext(void 0);
function useBi() {
  const context = useContext(BiContext);
  if (context === void 0) {
    throw new Error("useBi must be used within a BiProvider");
  }
  return context;
}
export {
  BiContext,
  useBi
};
//# sourceMappingURL=bi-context.js.map
